const areAllchildrenSelected = (numberOfSelected, selectedOrDisabledCount, clickedOnPartiallySelectedRow, containsUnselectable, allChildren) => {
  if (!allChildren || allChildren.length === 0) return false;
  if (numberOfSelected === allChildren.length) return true;
  if (clickedOnPartiallySelectedRow && containsUnselectable) return true;
  if (selectedOrDisabledCount === allChildren.length) return true;
  return false;
};
const shouldRunSelectAll = (selectedRows, selectAll, interactive) => {
  if (selectedRows.size === 0) return true;
  if (selectAll === true && !interactive) return true;
  if (selectAll === true && selectedRows.size > 0) return false;
  if (selectAll === true) return true;
  return false;
};
const reducer = (prevState, action) => {
  switch (action.type) {
    case 'selectRow':
      {
        const selectedRows = new Set(action.selectedRows);
        return {
          ...prevState,
          selectedRows,
          selectAll: action.selectAll,
          hideSelectAll: action.hideSelectAll
        };
      }
    case 'clearPartiallySelectedRows':
      {
        return {
          ...prevState,
          partiallySelectedRows: []
        };
      }
    case 'parentChildSelection':
      {
        const {
          rowKey,
          selected,
          selectedRows,
          selectAll
        } = action;
        const {
          getDataNode,
          getParentsRowKey,
          getRowIndex,
          getChildNodesRowKey,
          readonlyRows,
          disabledRows,
          readOnlyAndSelectedRows
        } = action.props;
        const newSelections = new Set([...(selectedRows ?? []), ...(readOnlyAndSelectedRows ?? [])]);
        const shouldRun = shouldRunSelectAll(newSelections, selectAll, action.interactive);
        if (shouldRun) {
          // no need to process parent-child selection when select all is clicked
          let mixState = false;
          if ((readonlyRows?.size ?? 0) > 0 && (readOnlyAndSelectedRows?.size ?? 0) > 0 && (readonlyRows?.size ?? 0) > (readOnlyAndSelectedRows?.size ?? 0)) {
            mixState = true;
          }
          return {
            ...prevState,
            partiallySelectedRows: [],
            selectedRows: new Set([]),
            selectAll: mixState ? 'mixed' : selectAll ?? false,
            hideSelectAll: action.hideSelectAll
          };
        }
        let partiallySelectedRows = [];
        const selectedIndex = getRowIndex && rowKey ? getRowIndex(rowKey) : -1;
        const node = selectedIndex !== -1 && getDataNode(selectedIndex);
        if (node && selected || newSelections?.size === 0 && readOnlyAndSelectedRows && readOnlyAndSelectedRows?.size > 0) {
          newSelections?.forEach(selectedRowKey => {
            const rowIndex = getRowIndex && rowKey ? getRowIndex(selectedRowKey) : -1;
            const rowNode = selectedIndex !== -1 && getDataNode(rowIndex);
            if (rowNode && rowNode.hasChildren) {
              const childRows = getChildNodesRowKey && selectedRowKey ? getChildNodesRowKey(selectedRowKey) : undefined;
              childRows?.forEach(childRow => {
                if (!readonlyRows?.has(childRow) && !disabledRows?.has(childRow)) newSelections.add(childRow);
              });
            }

            // handle selection/unselection of parent
            if (rowNode && rowNode.hasChildren) {
              newSelections.add(selectedRowKey);
            } else if (rowNode && rowNode.hasChildren) {
              newSelections.delete(selectedRowKey);
            } else newSelections.add(selectedRowKey);
            if (rowKey && rowKey === selectedRowKey && partiallySelectedRows?.includes(rowKey)) {
              newSelections.delete(rowKey);
            }
          });
        } else {
          if (node && node.hasChildren && !selected) {
            const children = getChildNodesRowKey && getChildNodesRowKey(rowKey);
            children?.forEach(childRow => {
              if (newSelections.has(childRow)) {
                if (!((readonlyRows?.has(childRow) || disabledRows?.has(childRow)) && (selectedRows?.has(childRow) || selectAll === true))) !readonlyRows?.has(childRow) && newSelections.delete(childRow);
              }
            });
          }
        }
        if (!selected && rowKey && newSelections) {
          const parents = getParentsRowKey?.(rowKey);
          parents?.forEach(child => {
            const children = getChildNodesRowKey?.(child);
            children?.forEach(node => {
              if (!newSelections?.has(node) && !readonlyRows?.has(child)) {
                newSelections.delete(child);
                return;
              }
            });
          });
          if (newSelections.size === 0) {
            partiallySelectedRows = [];
          }
          for (let i = 0; i < partiallySelectedRows.length; i++) {
            const key = partiallySelectedRows[i];
            const allChildren = getChildNodesRowKey?.(key);
            let match = false;
            allChildren?.forEach(child => {
              const isSelected = newSelections.has(child) || readOnlyAndSelectedRows?.has(child);
              if (isSelected && !disabledRows?.has(child)) {
                match = true;
                return;
              }
            });
            if (!match) {
              const index = partiallySelectedRows.indexOf(key);
              if (index > -1) {
                partiallySelectedRows.splice(index, 1);
              }
            }
          }
        }
        // handle partial selections
        const rowsToSelect = newSelections?.size > 0 ? newSelections : new Set([rowKey]);
        rowsToSelect.forEach(key => {
          const parents = getParentsRowKey && getParentsRowKey(key);
          parents?.forEach(parent => {
            const clickedOnPartiallySelectedRow = parent === rowKey && partiallySelectedRows?.includes(rowKey);
            let containsUnselectable = false;
            let numberOfSelected = 0;
            let numberOfNonDisabledSelected = 0;
            let unselectedDisabledRows = false;
            let selectedOrDisabledCount = 0;
            let hasSelected = false;
            const allChildren = getChildNodesRowKey && getChildNodesRowKey(parent);
            allChildren?.forEach(child => {
              if (disabledRows?.has(child)) unselectedDisabledRows = true;
              if (newSelections?.has(child) || readOnlyAndSelectedRows?.has(child)) {
                ++numberOfSelected;
                if (parent !== child) {
                  if (!disabledRows?.has(child)) ++numberOfNonDisabledSelected;
                }
              }
              if (parent !== child && newSelections?.has(child) && !disabledRows?.has(child)) hasSelected = true;
              if ((newSelections?.has(child) || disabledRows?.has(child)) && parent !== child) ++selectedOrDisabledCount;
              if (!disabledRows?.has(child) && parent !== child) {
                ++numberOfNonDisabledSelected;
              }
              if (!newSelections?.has(child) && parent !== child && disabledRows?.has(child)) if (readOnlyAndSelectedRows?.has(child)) {
                if (!disabledRows?.has(child)) ++numberOfNonDisabledSelected;
              }
              if (disabledRows?.has(child)) containsUnselectable = true;
            });
            if (clickedOnPartiallySelectedRow && containsUnselectable) {
              newSelections?.forEach(value => {
                if (allChildren?.includes(value)) newSelections.delete(value);
              });
            }
            if (numberOfNonDisabledSelected === 0 && partiallySelectedRows?.includes(parent) && (disabledRows?.size ?? 0) > 0) {
              partiallySelectedRows.splice(partiallySelectedRows.indexOf(parent), 1);
            }
            if (rowKey === parent && unselectedDisabledRows && partiallySelectedRows?.includes(parent)) {
              partiallySelectedRows.splice(partiallySelectedRows.indexOf(parent), 1);
            }
            if (numberOfSelected === 0 || clickedOnPartiallySelectedRow && containsUnselectable) {
              if (newSelections.has(parent)) newSelections.delete(parent);
              partiallySelectedRows.splice(partiallySelectedRows.indexOf(parent), 1);
            } else if (allChildren && allChildren?.length > selectedOrDisabledCount) {
              if (!partiallySelectedRows.includes(parent) && hasSelected) {
                const length = partiallySelectedRows.length;
                partiallySelectedRows[length] = parent;
              }
              if (newSelections.has(parent) && selectAll === 'mixed') newSelections.delete(parent);
            } else {
              const addParent = areAllchildrenSelected(numberOfSelected, selectedOrDisabledCount, clickedOnPartiallySelectedRow, containsUnselectable, allChildren);
              if (addParent && parent !== rowKey && !disabledRows?.has(parent)) newSelections.add(parent);
            }
          });
          partiallySelectedRows = partiallySelectedRows.filter(value => {
            return !newSelections.has(value);
          });
        });
        const {
          areRowsVisible,
          rowCount,
          hideSelectAll,
          columnHeadersVisible
        } = action.props;
        const selectedRowsValidated = !areRowsVisible ? true : areRowsVisible(newSelections);
        const disabledCount = disabledRows?.size || 0;
        let selectAllState;
        if (selectedRowsValidated && hideSelectAll !== true && rowCount !== 0 && columnHeadersVisible !== false && newSelections.size >= rowCount - disabledCount) {
          selectAllState = disabledCount > 0 && selectAll !== true ? false : newSelections?.size === rowCount ? true : 'mixed';
        } else if (newSelections.size > 0 && selectAll !== true) {
          selectAllState = 'mixed';
        } else {
          selectAllState = false;
        }
        return {
          ...prevState,
          selectedRows: selectAll === true ? undefined : newSelections,
          selectAll: selectAll === false ? false : selectAllState,
          hideSelectAll: action.hideSelectAll,
          partiallySelectedRows
        };
      }
    default:
      return prevState;
  }
};
const init = (selectedRows, partiallySelectedRows) => {
  return {
    selectedRows,
    partiallySelectedRows
  };
};
export const TreeTableState = {
  init,
  reducer
};
//# sourceMappingURL=TreeTableState.js.map